import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Link from "../../../components/Link"

const NatashaPage = props => {
    const {
        breadcrumb: { crumbs },
    } = props.pageContext
    var customCrumbLabel = props.location.pathname
        .replace("-", " ")
        .replace(/.*\//g, "")
    return (
        <Layout location={props.location}>
            <Helmet>
                <html className="memberpage" lang="da" />
            </Helmet>
            <div className="content-wide">
                <div className="wide-container">
                    <div className="wide-inner">
                        <Breadcrumb
                            crumbs={crumbs}
                            crumbSeparator=" / "
                            crumbLabel={customCrumbLabel}
                        />
                    </div>
                </div>
            </div>
            <div className="content-wide">
                <div className="wide-container">
                    <div className="wide-inner">
                        <div className="space-8"></div>

                        <div className="grid">
                            <div className="member-2col-left">
                                <div className="member-inner">
                                    <h1>Natasha Bøgh Harvey Engelbredt</h1>
                                    <h3>Professional</h3>
                                    <div
                                        class="table-container"
                                        role="table"
                                        aria-label="Destinations"
                                    >
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Date of employment at Emento
                                            </div>
                                            <div class="flex-row" role="cell">
                                                August 2021
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Title
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Project Manager
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Responsibilities
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Implementation of the digital careguide and the internal onboarding and learning strategy
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Educational background
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Bachelor and Master of Science in Educational Science
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Previous positions/industries
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Administrative Officer at the Central Denmark Region, worked within hospital operation, development projects in the clinics and management service.
                                            </div>
                                        </div>
                                    </div>
                                    <h3>Personal</h3>
                                    <div
                                        class="table-container"
                                        role="table"
                                        aria-label="Destinations"
                                    >
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Bucket list no. 1
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Drink champagne on a beach on the Maldives and watch the sun go down
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Favorite music
                                            </div>
                                            <div class="flex-row" role="cell">
                                                I have a diverse taste in music, but my top three on Spotify are quite consistent: 1. Minds of 99, 2. Suspekt and 3. Disclosure
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Biggest food or drink consumption
                                            </div>
                                            <div class="flex-row" role="cell">
                                                COFFEE(!) and yoghurt with granola
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Best TV series
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Forever and always Greys Anatomy!
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Extraordinary skill
                                            </div>
                                            <div class="flex-row" role="cell">
                                                I can touch my nose tip with my tongue
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Preferred traveling style
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Anything that runs on wheels; car, bike or train!
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                My friends recognizes me for
                                            </div>
                                            <div class="flex-row" role="cell">
                                                My laugh, my honest/upfront approach, loyalty and caring nature
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                As a kid, I wanted to become
                                            </div>
                                            <div class="flex-row" role="cell">
                                                A police officer, but being only 160 cm that would obviously never gonna happen..
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Social links
                                            </div>
                                            <div class="flex-row" role="cell">
                                                <Link to="https://www.linkedin.com/in/natasha-engelbredt/" target="_blank" rel="noreferrer">
                                                    LinkedIn
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="member-2col-middle">
                                <div className="member-hero-inner">
                                    <div className="member-hero-box">
                                        <div className="member-hero-image">
                                            <img
                                                src="/images/portraits/internal/natasha_hero.jpg"
                                                alt=""
                                            />
                                        </div>
                                        <h3>Feels like: Brave</h3>
                                        Strength
                                        <div className="full-bar">
                                            <div className="bar size-80" />
                                        </div>
                                        Artistic
                                        <div className="full-bar">
                                            <div className="bar size-70" />
                                        </div>
                                        Spontaneous
                                        <div className="full-bar">
                                            <div className="bar size-80" />
                                        </div>
                                        Determined
                                        <div className="full-bar">
                                            <div className="bar size-100" />
                                        </div>
                                        Polite
                                        <div className="full-bar">
                                            <div className="bar size-80" />
                                        </div>
                                        Playful
                                        <div className="full-bar">
                                            <div className="bar size-80" />
                                        </div>
                                        Empathy
                                        <div className="full-bar">
                                            <div className="bar size-90" />
                                        </div>
                                        Intelligence
                                        <div className="full-bar">
                                            <div className="bar size-90" />
                                        </div>
                                        Brave
                                        <div className="full-bar">
                                            <div className="bar size-100" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="member-2col-right">
                                <div className="member-childhood-inner">
                                    <div
                                        className="member-childhood-image"
                                        style={{
                                            backgroundImage: `url(/images/portraits/internal/natasha_child.jpg)`,
                                        }}
                                    >
                                        <div className="blur-bg">
                                            <img
                                                src="/images/portraits/internal/natasha_child.jpg"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NatashaPage
